export default __webpack_public_path__ + "static/media/ruler.9650ff3d.ogg";